import React from 'react'
import { NavLink } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <div>

      <div className='footer'>
        <div className="footer-menu">
          <ul className='footer-menu'>



            <li className='footer-item'>
              <NavLink className={({ isActive }) => (isActive ? 'active-footer' : 'footer-link')} to="/terms-of-use">
                Terms of Use
              </NavLink>
            </li>

            <li className='footer-item'>
              <NavLink className={({ isActive }) => (isActive ? 'active-footer' : 'footer-link')} to="/privacy-policy">
                Privacy Policy
              </NavLink>
            </li>

            <li className='footer-item'>
              <NavLink className={({ isActive }) => (isActive ? 'active-footer' : 'footer-link')} to="/acknowledgement">
                Acknowledgement
              </NavLink>

            </li>

            <div style={{ display: "none" }}>



                <a href="https://clustrmaps.com/site/1bz1u" title="Visit tracker">
                <img src="//www.clustrmaps.com/map_v2.png?d=PVKO3A-97XCBgQRdAHzAwH3GrQ7UGo6b3w35b6PC-Lg&cl=ffffff" alt='Visit tracker'/>
                </a>
              </div>

            <li className='footer-item'>
                <a className="footer-link" href='https://clustrmaps.com/site/1bz1u' target="_blank" rel="noreferrer">Website Visitors <FaExternalLinkAlt /></a>
              </li>

            {/* <li className='footer-item'>
              <NavLink className={({ isActive }) => (isActive ? 'active-footer' : 'footer-link')} to="/report-a-risk">
                Report a Risk
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Footer